export enum BoldIcons {
    ARROW_LEFT_1 = '52-Arrows-Diagrams/01-Arrows/arrow-left-1'
}
